import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(3), 0],
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/InputQuestion/useStyles.js